import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { computed } from 'mobx';
import { Model, referenceOne } from 'libx';
import moment from 'moment';
var Transaction = (_class = /*#__PURE__*/function (_Model) {
  function Transaction() {
    _classCallCheck(this, Transaction);
    return _callSuper(this, Transaction, arguments);
  }
  _inherits(Transaction, _Model);
  return _createClass(Transaction, [{
    key: "job",
    get: function get() {
      return referenceOne(this.rootStore.jobStore.jobs, this.metadata.job_id);
    }
  }, {
    key: "member",
    get: function get() {
      return referenceOne(this.rootStore.memberStore.members, "".concat(this.rootStore.sessionStore.workspace.id, "/").concat(this.metadata.user_public_id));
    }
  }, {
    key: "team",
    get: function get() {
      if (this.job && this.job.ownerTeamId) {
        return referenceOne(this.rootStore.teamStore.teams, this.job.ownerTeamId);
      }
      return null;
    }
  }, {
    key: "billingMethod",
    get: function get() {
      return referenceOne(this.rootStore.billingStore.billingMethods, this.billingMethodId);
    }
  }, {
    key: "parse",
    value: function parse(json) {
      return {
        amount: json.amount,
        billingMethodId: json.billing_method_id,
        payoutMethodId: json.payout_method_id,
        dateCreated: moment(json.date_created),
        id: json.id,
        metadata: json.metadata,
        transactionType: json.transaction_type,
        version: json.version
      };
    }
  }]);
}(Model), _applyDecoratedDescriptor(_class.prototype, "job", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "job"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "member", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "member"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "team", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "team"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "billingMethod", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "billingMethod"), _class.prototype), _class);
export { Transaction as default };
//# sourceMappingURL=Transaction.js.map
